/*
 * @@Author: MuYang
 */
import Api from './api'
import response from '../../utils/response'

// 获取schema
export async function requestSchema (
  {
    tenantType,
    objectApiName,
    layoutApiName,
    curAuthCode
  },
  headerParams
) {
  const {type, url} = Api.getLayoutInfo
  const computedUrl = `${url}/${tenantType}/${objectApiName}/${layoutApiName}/${curAuthCode}`
  const {isOk, content} = await response(
    {
      method: type,
      url: computedUrl,
      params: {
        tenantType
      },
      headerParams,
      option: {
        loadingOptions: false
      }
    }
  )
  if (isOk) {
    return content
  }
}

// 获取当前页面的规则
export async function requestPageRule (
  {
    tenantType,
    objectApiName,
    layoutApiName,
    curAuthCode
  },
  headerParams
) {
  const {type, url} = Api.getPageRule
  const uri = `${url}/${tenantType}/${objectApiName}/${layoutApiName}/${curAuthCode}`
  const {isOk, content} = await response(
    {
      method: type,
      url: uri,
      params: {
        tenantType
      },
      headerParams,
      option: {
        loadingOptions: false
      }
    }
  )
  if (isOk) {
    return content || {}
  }
}

// 打印
export async function requestPrint (params) {
  const {objectApiName, operationApiName, id, printApiName, menuApiName} = params
  const {url} = Api.print
  window.open(`${window.fe.baseUrl}${url}/${objectApiName}/${operationApiName}?printApiName=${printApiName}&sequenceId=${id}&menuApiName=${menuApiName}&_t=${new Date().getTime()}`)
}